/**
 * @description Namespaces used by various Player Services applications
 */
export enum Namespace {
	/**
	 * @description Namespace used by desktop Skin class
	 * @type {Namespace.DESKTOP_SKIN}
	 */
	DESKTOP_SKIN = 'PARADesktopSkin',

	/**
	 * @description Namespace used by standalone Mobile Skin class
	 * @type {Namespace.MOBILE_SKIN}
	 */
	MOBILE_SKIN = 'PARAMobileSkin',

	/**
	 * @description Desktop Skin sample plugin namespace
	 * @type {Namespace.DESKTOP_SKIN_PLUGIN_SAMPLE}
	 */
	DESKTOP_SKIN_PLUGIN_SAMPLE = 'SkinPluginSample',

	/**
	 * @description Desktop Skin SideBar plugin namespace
	 * @type {Namespace.DESKTOP_SKIN_PLUGIN_SIDEBAR}
	 */
	DESKTOP_SKIN_PLUGIN_SIDEBAR = 'SkinSideBar',

	/**
	 * @description Desktop Skin MultiCam plugin namespace
	 * @type {Namespace.DESKTOP_SKIN_PLUGIN_MULTI_CAM}
	 */
	DESKTOP_SKIN_PLUGIN_MULTI_CAM = 'SkinMultiCam',

	/**
	 * @description Desktop Skin Related Videos plugin namespace
	 * @type {Namespace.DESKTOP_SKIN_PLUGIN_RELATED_VIDEOS}
	 */
	DESKTOP_SKIN_PLUGIN_RELATED_VIDEOS = 'SkinRelatedVideos',

	/**
	 * @description Desktop Skin MultiStream plugin namespace
	 * @type {Namespace.DESKTOP_SKIN_PLUGIN_MULTI_STREAM}
	 */
	DESKTOP_SKIN_PLUGIN_MULTI_STREAM = 'SkinMultiStream',

	/**
	 * @description Tag sample plugin namespace
	 * @type {Namespace.TAG_PLUGIN_SAMPLE}
	 */
	TAG_PLUGIN_SAMPLE = 'TagPluginSample',

	/**
	 * @description Tag Data Service plugin namespace
	 * @type {Namespace.TAG_DATA_SERVICE}
	 */
	TAG_DATA_SERVICE = 'TagDataService',

	/**
	 * @description Tag Nerd Mode plugin namespace
	 * @type {Namespace.TAG_PLUGIN_NERD_MODE}
	 */
	TAG_PLUGIN_NERD_MODE = 'TagPluginNerdMode',

	/**
	 * @description Tag Mobile Web UI plugin namespace
	 * @type {Namespace.TAG_PLUGIN_MOBILE_WEB_UI}
	 */
	TAG_PLUGIN_MOBILE_WEB_UI = 'TagPluginMobileWebUI',
}